// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--gHC63","label":"a10a3f92e9--label--vKG9J","link":"a10a3f92e9--link--TftI1","text":"a10a3f92e9--text--gfnes"};